import { type AnnexPlannedWorkDto, datePl } from '@bqcrm/shared';
import { Alert, Anchor, Text } from '@mantine/core';
import { IconCalendarEvent } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { Fragment } from 'react';
import { Link } from 'react-router';
import { api } from '../../api';

/**
 * QA qa10301331 P11: aneks do zakresu, który ma już zaplanowaną albo trwającą pracę — „zakres ma zaplanowaną realizację ZD/… na dd.mm”.
 * Po wydaniu aneksu planujący i koordynator branży dostają powiadomienie.
 */
export function AnnexPlannedWorkAlert({ annexId, caseId, issued }: { annexId: string; caseId: string; issued: boolean }) {
  const q = useQuery({ queryKey: ['annex-planned-work', annexId], queryFn: () => api<AnnexPlannedWorkDto[]>(`/contracts/${annexId}/planned-work`), retry: false });
  const list = q.data ?? [];
  if (!list.length) return null;
  return (
    <Alert color="yellow" icon={<IconCalendarEvent />} mb="md" title={list.some((w) => w.status !== 'zaplanowane') ? 'Zakres ma rozpoczętą pracę' : 'Zakres ma zaplanowaną realizację'}>
      <Text size="sm">
        {list.map((w, i) => (
          <Fragment key={w.taskId}>
            {i > 0 && '; '}
            {w.tradeName} — {w.label.toLowerCase()}{' '}
            <Anchor component={Link} to={`/sprawy/${caseId}?zakladka=prace&zadanie=${w.taskId}`} size="sm">
              {w.number}
            </Anchor>
            {w.status === 'zaplanowane' ? (w.dateFrom ? ` na ${datePl(w.dateFrom)}` : '') : w.status === 'wstrzymane' ? ' (wstrzymana)' : ' (w toku)'}
          </Fragment>
        ))}
        .
      </Text>
      <Text size="xs" c="dimmed" mt={4}>
        {issued ? 'Osoba, która zaplanowała pracę przed wydaniem aneksu, i koordynator branży dostali powiadomienie.' : 'Po wydaniu aneksu planujący i koordynator branży dostaną powiadomienie.'} Uzgodnij, czy prace z aneksu zmieszczą się w tej wizycie.
      </Text>
    </Alert>
  );
}
